/**
 * The Offload Area View.
 * Sets up the rendering, click events and drag&drop events for the offload area.
 */

var VRC = VRC || {};

	VRC.BulkOffloadAraeView = (function () {
	var NUMBER_OF_COLUMNS = 5;
	var MARGIN_PRESENTAGE = 0.5;

	var _size;

	var _queries = {
		container: "#bulk-state-offloading",
		offloadEvents: '.request'
	};

	var init = function () {
		var port = VRC.BulkToolbarView.getSelectedPort();

		var bulkTankRequests = VRC.BulkTankManager.getOffloadEvents(port);

		var ctx = createContext(bulkTankRequests);

		render(ctx);

	};

	var attachAllClickable = function () {
		var $container = $(_queries.container);
		var $offloadEvents = $container.find(_queries.offloadEvents);
		attachClickable($offloadEvents);
	};

	var attachClickable = function ($elements) {
		$elements.unbind('click').click(function (e) {
			var $offloadEvent = $(e.target).closest('.request');
			var bulkTankId = $offloadEvent.attr('data-bulktank-id');
			var voyageBulkId = $offloadEvent.attr('data-voyagebulk-id');

			VRC.BulkModalView.render(bulkTankId, {highlight: voyageBulkId});
		})

	};

	var attachDraggable = function () {
		var offloadDeck = $(".bulk_deck.offload");
		interact(".bulk_deck.offload").dropzone({
			accept: ".main",
			ondropactivate: function () {
				// add active dropzone feedback
				offloadDeck.addClass("can-drop");
			},
			ondragenter: function (event) {
				var dropzoneElement = $(event.target);

				// feedback the possibility of a drop
				dropzoneElement.addClass("drop-target");
			},
			ondragleave: function (event) {
				var dropzoneElement = $(event.target);

				// remove the drop feedback style
				dropzoneElement.removeClass("drop-target");
			},
			ondrop: function (event) {
				var draggableElement = event.relatedTarget,
					dropzoneElement = $(event.target);

				dropzoneElement.removeClass("drop-target");

				//GetOffloadableContent
				var bulkTankId = draggableElement.getAttribute('data-bulk-tank-id');
				var bulkTank = VRC.BulkTankManager.getBulkTankById(bulkTankId);
				var offloadableContent = bulkTank.getOffloadableContent();

				//Create Temp html
				var placeHolderHtml = Handlebars.partials['bulk_cargo_request']({main: getMainJson()});
				dropzoneElement.append(placeHolderHtml);
				var $placeHolderHtml = dropzoneElement.children().last();

				showPopup($placeHolderHtml, offloadableContent, bulkTank)
			},
			ondropdeactivate: function () {
				offloadDeck.removeClass("can-drop");
			}
		});
	};

	var getMainJson = function () {
		return {size: _size, margin: MARGIN_PRESENTAGE};
	};

	var showInputPopup = function ($placeHolder, droppedElement) {

		var onConfirm = function ($placeHolder, inputElements, json) {
			var voyageBulk = insertBulkAction(inputElements, droppedElement);
			var voyageBulkJson = voyageBulk.toJson();
			voyageBulkJson.main = getMainJson();
			var placeHolderHtml = Handlebars.partials['bulk_cargo_request'](voyageBulkJson);
			$placeHolder.popover('destroy');
			$placeHolder.replaceWith(placeHolderHtml);

			attachAllClickable();
		};

		var onCancel = function () {
			$placeHolder.remove();
		};

		var portId = VRC.BulkToolbarView.getSelectedPort();
		var portPort = VRC.MasterDataService.getPort(portId);

		if(portPort){
			var config = {
				action: 'offload',
				title: 'Offloading  to ' + portPort.name
			};

			VRC.BulkLoadingPopoverView.show($placeHolder, droppedElement, onConfirm, onCancel, config)
		}
		else{
		  VRC.ErrorHandleService.showMessage('No port selected', G_MSG_TYPE_WARNING);
			onCancel();
		}

	};

	var insertBulkAction = function (inputElements, json) {

		var bulkTank = VRC.BulkTankManager.getBulkTankById(json.bulkTankId);
		var containerId = json.containerId;
		//Getting values from popover

		var qty = VRC.Utils.Number.parseFloat(inputElements.$valueQty.val());
		qty = qty || 0;
		var qtyRob = VRC.Utils.Number.parseFloat(inputElements.$qtyRob.val());
		qtyRob = qtyRob || 0;
		var date = inputElements.$date.val();
		var inputRemarks = inputElements.$remarkField.val();

		var lastContainerAction = bulkTank.getLatestContentByContainerId(containerId);
		var portId = VRC.BulkToolbarView.getSelectedPort();
		var voyageBulk = VRC.VoyageBulk(lastContainerAction.toJson());

		//Todo do in VoyageBulk
		voyageBulk.createNewId();
		voyageBulk.setAction(g_actions.offload);
		voyageBulk.setDate(date);
		voyageBulk.setValueQty(qty);
		voyageBulk.setQtyRob(qtyRob);
		voyageBulk.setRemarks(inputRemarks);
		voyageBulk.setOriginId(portId);
		voyageBulk.setOriginName();
		voyageBulk.setDestinationId(undefined);
		voyageBulk.setDestinationName(undefined);
		voyageBulk.setDisplayPort();
		if (inputElements.$valueQty) {
			voyageBulk.setBulkTypeId(inputElements.$bulkTypeId.val());
			voyageBulk.setBulkTypeName();
		}

		//END Todo

		bulkTank.addContent(voyageBulk);
		//UpdateUi
		VRC.BulkStateView.renderTank(bulkTank);

		return voyageBulk;
	};

	var showSelectCargoId = function ($placeHolder, content, bulkTank) {

		var popOverHtml = WELL.Handlebars.VRC.offload_action_selector({
			units: VRC.MasterDataService.getBulkValueUnitsAsArray(),
			content: content
		});

		$placeHolder.attr('data-content', popOverHtml);
		$placeHolder.popover({html: true, placement: 'left auto', sanitize: false });
		$placeHolder.popover('show');

		var $popover = $placeHolder.next();
		var $cargoItemsBtn = $popover.find('.offload-popup__cargo-list__btns');
		var $cancelBtn = $popover.find('.bulk-offload-cancel');

		$cargoItemsBtn.click(function (e) {
			e.preventDefault();
			var $btn = $(this);
			$btn.prop('disabled', true);
			var containerId = $btn.attr('data-container-id');

			if (!containerId) {
				containerId = "undefined";
			}
			var bulkTankCargoItem = _.findWhere(content, {containerId: containerId});

			showInputPopup($placeHolder, bulkTankCargoItem, bulkTank)
		});

		$cancelBtn.click(function (e) {
			e.preventDefault();
			$placeHolder.popover('destroy');
			$placeHolder.remove();
		});
	};

	var showPopup = function ($placeHolder, bulkTankCargoItems, bulkTank) {

		if (bulkTankCargoItems.length > 1) {
			showSelectCargoId($placeHolder, bulkTankCargoItems, bulkTank);
		}
		else if (bulkTankCargoItems.length === 1) {
			showInputPopup($placeHolder, bulkTankCargoItems[0], bulkTank);
		}

		else {
			$placeHolder.remove();
			console.error('There is no offloadable content in this tank');
		}
	};

	var createContext = function (bulkTankRequests) {

		_.each(bulkTankRequests, function (request) {
			request.tankShape = request["valueUnit"] && request["valueUnit"] === "mt" ? "circle" : "square";
		});

		_size = VRC.BulkViewUtil.calculateSize(MARGIN_PRESENTAGE, NUMBER_OF_COLUMNS);

		var portColors = findPortColorsInRequests(bulkTankRequests);

		return {
			bulkTankRequests: bulkTankRequests,
			size: _size,
			margin: MARGIN_PRESENTAGE,
			portColors: portColors,
			units: VRC.MasterDataService.getBulkValueUnitsAsArray()
		};
	};

	var findPortColorsInRequests = function (requests) {
		return _.chain(requests).groupBy(function (request) {
			return request.originName || request.destinationName;
		}).map(function (group) {
			var item = _.first(group);
			return {
				portName: item.displayPort,
				portColorCode: item.portColorCode
			};
		}).sortBy(function (request) {
			return request.portColorCode;
		}).value();
	};

	var render = function (context) {
		var $container = $(_queries.container);

		var content = WELL.Handlebars.VRC.bulk_offloading_area(context);
		$container.html(content);

		attachDraggable();
		attachAllClickable();
	};



	return {
		init: init,
		render: render
	}
})();
